export default function showIntro( state = {
  showIntro: true,
}, action ) {
  switch ( action.type ) {
    case 'HIDE_INTRO':
      return {
        showIntro: false,
      };
    case 'SHOW_INTRO':
      return {
        showIntro: true,
      };
    default:
      return state;
  }
}